package com.daytimegaming.ourdailyfinances.di

import com.daytimegaming.ourdailyfinances.data.repository.AccountRepositoryImpl
import com.daytimegaming.ourdailyfinances.data.repository.AuthRepositoryImpl
import com.daytimegaming.ourdailyfinances.data.repository.BudgetRepositoryImpl
import com.daytimegaming.ourdailyfinances.data.repository.DashboardRepositoryImpl
import com.daytimegaming.ourdailyfinances.data.repository.EventRepositoryImpl
import com.daytimegaming.ourdailyfinances.data.repository.RealEstateRepositoryImpl
import com.daytimegaming.ourdailyfinances.data.repository.TransactionRepositoryImpl
import com.daytimegaming.ourdailyfinances.data.repository.UserRepositoryImpl
import com.daytimegaming.ourdailyfinances.domain.account.AccountEventBus
import com.daytimegaming.ourdailyfinances.domain.dashboard.DashboardEventBus
import com.daytimegaming.ourdailyfinances.domain.plaid.PlaidEventBus
import com.daytimegaming.ourdailyfinances.domain.plaid.PlaidItemsEventBus
import com.daytimegaming.ourdailyfinances.domain.realestate.RealEstateEventBus
import com.daytimegaming.ourdailyfinances.domain.repository.AccountRepository
import com.daytimegaming.ourdailyfinances.domain.repository.AuthRepository
import com.daytimegaming.ourdailyfinances.domain.repository.BudgetRepository
import com.daytimegaming.ourdailyfinances.domain.repository.DashboardRepository
import com.daytimegaming.ourdailyfinances.domain.repository.EventRepository
import com.daytimegaming.ourdailyfinances.domain.repository.RealEstateRepository
import com.daytimegaming.ourdailyfinances.domain.repository.TransactionRepository
import com.daytimegaming.ourdailyfinances.domain.repository.UserRepository
import com.daytimegaming.ourdailyfinances.presentation.home.RecentSpendingManager
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.analytics.analytics
import dev.gitlive.firebase.auth.auth
import org.koin.dsl.module

fun repositoryModule() = module {
    single { Firebase.analytics }
    single { Firebase.auth }
    single<AuthRepository> { AuthRepositoryImpl(get()) }
    single<DashboardRepository> { DashboardRepositoryImpl(get()) }
    single<AccountRepository> { AccountRepositoryImpl(get()) }
    single<TransactionRepository> { TransactionRepositoryImpl(get()) }
    single<UserRepository> { UserRepositoryImpl(get(), get()) }
    single<BudgetRepository> { BudgetRepositoryImpl(get()) }
    single<RealEstateRepository> { RealEstateRepositoryImpl(get()) }
    single<EventRepository> { EventRepositoryImpl(get()) }
    single { PlaidEventBus() }
    single { PlaidItemsEventBus() }
    single { RealEstateEventBus() }
    single { DashboardEventBus() }
    single { AccountEventBus() }
    single { RecentSpendingManager() }
}
